import { h } from '@atomify/jsx';
import { useTranslate } from '@utilities/hooks';

import { FC_ATTRIBUTION_TRANSLATION_KEY, FC_WIDGET_HOOK } from '../../constants/friendly-captcha';

interface FriendlyCaptchaWidgetProps {
    classes?: string;
    mode?: 'widget' | 'text';
}

const Widget = ({ classes = '' }: { classes?: string }) => (
    <div
        class={`c-friendly-captcha-widget frc-captcha ${classes}`.trim()}
        {...{ [FC_WIDGET_HOOK]: true }}
    />
);

export const FriendlyCaptchaWidget = ({
    classes = '',
    mode = 'widget',
}: FriendlyCaptchaWidgetProps) => {
    if (mode === 'widget') return <Widget classes={classes} />;

    return (
        <div class={`c-friendly-captcha-attribution ${classes}`.trim()}>
            <Widget classes="u-hidden" />
            <p class="u-body-normal u-color-grey-50">
                {useTranslate(FC_ATTRIBUTION_TRANSLATION_KEY, { html: true })}
            </p>
        </div>
    );
};
